import { Button, Modal } from "semantic-ui-react";
import React, { useState } from "react";

const FRSClientSecretKeyModal = ({ open, onClose, keyValue }) => {

    const [showKey, setShowKey] = useState(false);

    const displayKeyValue = keyValue?.clientSecret;

    const showSecretKey = () => {
        setShowKey(true);
    }

    const copySecretKey = () => {
        navigator.clipboard.writeText(displayKeyValue);
    }

    const handleClose = () => {
        setShowKey(false);
        onClose();
    }

    return (
        <Modal
            open={open}
            size="small"
            closeIcon
            onClose={handleClose}
            closeOnDimmerClick={false}
            closeOnEscape={false}
        >
            <Modal.Header>FRS Client Secret Key</Modal.Header>
            <Modal.Content>
                <div className="masked">
                    {showKey ? displayKeyValue : "**** **** **** ****"}
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button positive onClick={showSecretKey}>Reveal</Button>
                <Button negative onClick={copySecretKey}>Copy</Button>
            </Modal.Actions>
        </Modal>
    )
}

export default FRSClientSecretKeyModal;